import { render, staticRenderFns } from "./MakePayment.vue?vue&type=template&id=fff7c522&scoped=true&"
import script from "./MakePayment.vue?vue&type=script&lang=js&"
export * from "./MakePayment.vue?vue&type=script&lang=js&"
import style0 from "./MakePayment.vue?vue&type=style&index=0&id=fff7c522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff7c522",
  null
  
)

export default component.exports